// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file requests/v1/shipping_rate_mapping_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { ShippingRateDefinitionType } from '../../settings/v1/shipping_rate_definition_type_pb';
import { file_settings_v1_shipping_rate_definition_type } from '../../settings/v1/shipping_rate_definition_type_pb';
import type { ShippingRateTier } from '../../settings/v1/shipping_rate_tier_pb';
import { file_settings_v1_shipping_rate_tier } from '../../settings/v1/shipping_rate_tier_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/shipping_rate_mapping_request.proto.
 */
export const file_requests_v1_shipping_rate_mapping_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ci9yZXF1ZXN0cy92MS9zaGlwcGluZ19yYXRlX21hcHBpbmdfcmVxdWVzdC5wcm90bxILcmVxdWVzdHMudjEimwQKGlNoaXBwaW5nUmF0ZU1hcHBpbmdSZXF1ZXN0EkEKCG1hcHBpbmdzGAEgAygLMi8ucmVxdWVzdHMudjEuU2hpcHBpbmdSYXRlTWFwcGluZ1JlcXVlc3QuTWFwcGluZxq5AwoHTWFwcGluZxISCgpjb3VudHJ5X2lkGAEgASgEElUKDnByb3ZpZGVyX3JhdGVzGAIgAygLMj0ucmVxdWVzdHMudjEuU2hpcHBpbmdSYXRlTWFwcGluZ1JlcXVlc3QuTWFwcGluZy5Qcm92aWRlclJhdGVzGsICCg1Qcm92aWRlclJhdGVzEloKDnNoaXBwaW5nX3JhdGVzGAEgAygLMkIucmVxdWVzdHMudjEuU2hpcHBpbmdSYXRlTWFwcGluZ1JlcXVlc3QuTWFwcGluZy5Qcm92aWRlclJhdGVzLlJhdGUSFQoNc2hpcHBpbmdfdHlwZRgCIAEoCRq9AQoEUmF0ZRIKCgJpZBgBIAEoBBIMCgRuYW1lGAIgASgJEjUKBHR5cGUYAyABKA4yJy5zZXR0aW5ncy52MS5TaGlwcGluZ1JhdGVEZWZpbml0aW9uVHlwZRIQCghjdXJyZW5jeRgEIAEoCRIWCglmcmVlX2Zyb20YBSABKAFIAIgBARIsCgVyYXRlcxgGIAMoCzIdLnNldHRpbmdzLnYxLlNoaXBwaW5nUmF0ZVRpZXJCDAoKX2ZyZWVfZnJvbUKFAQoPY29tLnJlcXVlc3RzLnYxQh9TaGlwcGluZ1JhdGVNYXBwaW5nUmVxdWVzdFByb3RvUAFaBC4vcGKiAgNSWFiqAgtSZXF1ZXN0cy5WMcoCC1JlcXVlc3RzXFYx4gIXUmVxdWVzdHNcVjFcR1BCTWV0YWRhdGHqAgxSZXF1ZXN0czo6VjFiBnByb3RvMw',
        [file_settings_v1_shipping_rate_definition_type, file_settings_v1_shipping_rate_tier]
    );

/**
 * @generated from message requests.v1.ShippingRateMappingRequest
 */
export type ShippingRateMappingRequest = Message<'requests.v1.ShippingRateMappingRequest'> & {
    /**
     * @generated from field: repeated requests.v1.ShippingRateMappingRequest.Mapping mappings = 1;
     */
    mappings: ShippingRateMappingRequest_Mapping[];
};

/**
 * Describes the message requests.v1.ShippingRateMappingRequest.
 * Use `create(ShippingRateMappingRequestSchema)` to create a new message.
 */
export const ShippingRateMappingRequestSchema: GenMessage<ShippingRateMappingRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_shipping_rate_mapping_request, 0);

/**
 * @generated from message requests.v1.ShippingRateMappingRequest.Mapping
 */
export type ShippingRateMappingRequest_Mapping = Message<'requests.v1.ShippingRateMappingRequest.Mapping'> & {
    /**
     * @generated from field: uint64 country_id = 1;
     */
    countryId: bigint;

    /**
     * @generated from field: repeated requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates provider_rates = 2;
     */
    providerRates: ShippingRateMappingRequest_Mapping_ProviderRates[];
};

/**
 * Describes the message requests.v1.ShippingRateMappingRequest.Mapping.
 * Use `create(ShippingRateMappingRequest_MappingSchema)` to create a new message.
 */
export const ShippingRateMappingRequest_MappingSchema: GenMessage<ShippingRateMappingRequest_Mapping> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_shipping_rate_mapping_request, 0, 0);

/**
 * @generated from message requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates
 */
export type ShippingRateMappingRequest_Mapping_ProviderRates =
    Message<'requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates'> & {
        /**
         * @generated from field: repeated requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates.Rate shipping_rates = 1;
         */
        shippingRates: ShippingRateMappingRequest_Mapping_ProviderRates_Rate[];

        /**
         * @generated from field: string shipping_type = 2;
         */
        shippingType: string;
    };

/**
 * Describes the message requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates.
 * Use `create(ShippingRateMappingRequest_Mapping_ProviderRatesSchema)` to create a new message.
 */
export const ShippingRateMappingRequest_Mapping_ProviderRatesSchema: GenMessage<ShippingRateMappingRequest_Mapping_ProviderRates> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_shipping_rate_mapping_request, 0, 0, 0);

/**
 * @generated from message requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates.Rate
 */
export type ShippingRateMappingRequest_Mapping_ProviderRates_Rate =
    Message<'requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates.Rate'> & {
        /**
         * @generated from field: uint64 id = 1;
         */
        id: bigint;

        /**
         * @generated from field: string name = 2;
         */
        name: string;

        /**
         * @generated from field: settings.v1.ShippingRateDefinitionType type = 3;
         */
        type: ShippingRateDefinitionType;

        /**
         * @generated from field: string currency = 4;
         */
        currency: string;

        /**
         * free_from is the cart subtotal the rate becomes free delivery from, in
         * the rate's currency. Optional because a rate with no free shipping
         * threshold has none, which is not the same as a threshold of zero —
         * that one is free from the first order.
         *
         * @generated from field: optional double free_from = 5;
         */
        freeFrom?: number | undefined;

        /**
         * rates are the tiers of the definition: the delivery cost and the
         * transit estimate per bound. A flat definition has a single unbounded
         * tier, an order amount or package weight one has a tier per band.
         *
         * @generated from field: repeated settings.v1.ShippingRateTier rates = 6;
         */
        rates: ShippingRateTier[];
    };

/**
 * Describes the message requests.v1.ShippingRateMappingRequest.Mapping.ProviderRates.Rate.
 * Use `create(ShippingRateMappingRequest_Mapping_ProviderRates_RateSchema)` to create a new message.
 */
export const ShippingRateMappingRequest_Mapping_ProviderRates_RateSchema: GenMessage<ShippingRateMappingRequest_Mapping_ProviderRates_Rate> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_shipping_rate_mapping_request, 0, 0, 0, 0);
